import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Input from '../../Common/ui/input'
import { Button } from '../../Common/ui/button'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import DropdownTextInput from '../../Common/ui/DropdownTextInput'
import { useTranslation } from 'react-i18next'
import { getVacancyGov, useCommonStore } from '../../Common/store/CommonStore'
import { Checkbox } from '../../Common/ui/checkbox'
import MultiSelectInput from '../../Common/ui/MultiSelect'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import SearchableSelectInput from '../../Common/ui/SearchableSelectInput'
import { useBoardMemberStore } from 'src/Containers/Governance/store/BoardMemberStore'
import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material'
import { toast } from 'react-toastify'
import { validateAndProcessImage } from '../../lib/utils'
import PhoneNumber from '../../Common/ui/PhoneNumber'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { VACANCY_GOV } from 'src/Entities/OrgEntities'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import { BODY_PREVIEW, COMPLIANCE_PREVIEW } from 'src/Entities/RoutePath'
import { useNavigate } from 'react-router'

const EditNodeDrawer = ({ nodes, setCurrentNode, currentNode, setEditState, editState, onEdit, loading, setLoading }) => {
    const { t } = useTranslation()
    const { register, handleSubmit, reset, resetField, setValue, formState: { errors, isSubmitting, isLoading }, control, setError, clearErrors } = useForm({
        mode: 'onChange',
        defaultValues: {
            displayName: currentNode?.displayName,
            firstName: currentNode?.firstName,
            lastName: currentNode?.lastName,
            designation: currentNode?.designation,
            level: currentNode?.level,
            department: currentNode?.department,
            emailId: currentNode?.emailId,
            phoneNumber: currentNode?.phoneNumber,
            role: currentNode?.role,
            fromDate: currentNode?.fromDate,
            toDate: currentNode?.toDate
        }
    })
    const [ selectedImage, setSelectedImage ] = useState(null)
    const [ openWarningVacantPopup, setOpenWarningVacantPopup ] = useState({ isOpen: false, name: 'isVacant', value: null })
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const { clearNodeModalData } = useBoardMemberStore()
    const { getAllRole, rollData, departmentByOrgId, designationByOrgId, getAllDepartmentByOrgId, getAllDesignationByOrgId } = useCommonStore()
    const [ roleData, setRoleData ] = useState([])
    const [ depByOrgId, setDepByOrgId ] = useState([])
    const [ desByOrgId, setDesByOrgId ] = useState([])
    const parentNodeValue = nodes.find((nds) => nds.id === currentNode.reportsTo)
    const orgId = localStorage.getItem('orgId')
    let fromMaxDate = new Date()
    fromMaxDate.setHours(0, 0, 0, 0)
    fromMaxDate = new Date(fromMaxDate.toISOString())
    let [ count, setCount ] = useState(0)
    const vacancyGovData = useCommonStore(state => state.vacancyGovData)
    useEffect(() => {
        setSelectedImage(currentNode.profilePic)
        getAllRole(orgId)
        getAllDepartmentByOrgId(orgId)
        getAllDesignationByOrgId(orgId)
        getVacancyGov(orgId, currentNode?.userId)
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        setCount(0)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [editState])
    useEffect(() => {
        if (count === 1) {
            if (!currentNode.displayName) {
                setCurrentNode({ ...currentNode, isVacant: true })
            }
        }
    }, [count])
    useEffect(() => {
        if (currentNode) {
            reset({
                displayName: currentNode?.displayName,
                firstName: currentNode?.firstName,
                lastName: currentNode?.lastName,
                designation: currentNode?.designation,
                level: currentNode?.level,
                department: currentNode?.department,
                emailId: currentNode?.emailId,
                phoneNumber: currentNode?.phoneNumber,
                role: currentNode?.role,
                fromDate: currentNode?.fromDate,
                toDate: currentNode?.toDate
            })
            if (count === 0) {
                setCount(1)
            }
            count++
        }
    }, [ currentNode, reset ])

    useEffect(() => {
        if (currentNode?.atPresent) {
            setValue('toDate', currentNode?.toDate)
        }
        if (rollData.length > 0) {
            setRoleData(rollData)
        }
        if (departmentByOrgId.length > 0) {
            setDepByOrgId(departmentByOrgId)
        }
        if (designationByOrgId.length > 0) {
            setDesByOrgId(designationByOrgId)
        }
    }, [ currentNode?.atPresent, reset, rollData, designationByOrgId, departmentByOrgId ])

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        if (!open) {
            reset()
            resetField(OnboardEntity.PHONE_NUMBER)
            setSelectedImage(null)
        }
        setEditState({ ...editState, [anchor]: open })
    }
    const resetAll = () => {
        reset()
    }
    const onSubmit = () => {
        setLoading(true)
        onEdit(currentNode, roleData, desByOrgId, depByOrgId, resetAll)
        clearNodeModalData()
        setSelectedImage(null)
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        validateAndProcessImage(file, setSelectedImage, setCurrentNode, t, toast)
        e.target.value = ''
    }

    const handleRemoveImage = () => {
        setCurrentNode((prevNode) => ({
            ...prevNode,
            profilePic: ''
        }))
        setSelectedImage(null)
    }
    useEffect(() => {
        if (currentNode?.isVacant === undefined) {
            setCurrentNode((prevNode) => ({ ...prevNode, isVacant: false }))
            resetField(OnboardEntity.FIRST_NAME)
            resetField(OnboardEntity.LAST_NAME)
            resetField(OnboardEntity.EMAILID)
            resetField(OnboardEntity.DESIGNATION_NAME)
        }
        if (currentNode?.isVacant) {
            if (currentNode) {
                reset({
                    designation: currentNode?.designation,
                    department: currentNode?.department,
                    fromDate: currentNode?.fromDate,
                    toDate: currentNode?.toDate,
                    role: currentNode?.role
                })
            }
        } else {
            if (currentNode) {
                reset({
                    displayName: currentNode?.displayName,
                    firstName: currentNode?.firstName,
                    lastName: currentNode?.lastName,
                    designation: currentNode?.designation,
                    level: currentNode?.level,
                    department: currentNode?.department,
                    emailId: currentNode?.emailId,
                    phoneNumber: currentNode?.phoneNumber,
                    role: currentNode?.role,
                    fromDate: currentNode?.fromDate,
                    toDate: currentNode?.toDate
                })
            }
        }
    }, [currentNode?.isVacant])

    useEffect(() => {
        if (currentNode?.atPresent === true) {
            setCurrentNode({ ...currentNode, toDate: new Date().toISOString() })
        } else {
            setCurrentNode({ ...currentNode, toDate: currentNode?.toDate })
        }
    }, [currentNode?.atPresent])

    const handleEditFieldsChange = (value, name) => {
        // if (name === OnboardEntity.PHONE_NUMBER) {
        //     resetField(OnboardEntity.PHONE_NUMBER)
        // }
        if (name === OnboardEntity.PHONE_NUMBER) {
            if (value) {
                // setCurrentNode(prevState => ({ ...prevState, [name]: value }))
                setCurrentNode((newNode) => ({
                    ...newNode,
                    phoneCountryCode: value.countryCode,
                    phoneCode: value.phNumberCode,
                    phoneNumber: value.phNumber
                }
                ))
            }
            return
        }
        if (name === OnboardEntity.FROM_DATE || name === OnboardEntity.IS_VACANT || name === OnboardEntity.TO_DATE || name === OnboardEntity.AT_PRESENT || name === OnboardEntity.ROLE || name === OnboardEntity.FIRST_NAME || name === OnboardEntity.DEPARTMENT_NAME || name === OnboardEntity.DESIGNATION_NAME) {
            setCurrentNode((currentNode) => ({ ...currentNode, [name]: (name === OnboardEntity.FROM_DATE || name === OnboardEntity.TO_DATE) ? value.toISOString() : value }))
        } else {
            setCurrentNode({ ...currentNode, [name]: value?.target?.value })
        }
    }

    // const lableComponent = (<div className='w-[100%] h-full pl-[10px] flex'>
    //     <Checkbox name={'atPresent'} checked={currentNode?.atPresent || currentNode?.isVacant === true} onCheckedChange={(e) => handleEditFieldsChange(e, 'atPresent')} />
    //     <label className='grc-label ml-2'>{t('Till Now')}</label>
    // </ div>)

    const handleCancelClose = () => {
        setEditState({ ...editState, right: false })
        reset()
        setCount(0)
        setSelectedImage(null)
        resetField(OnboardEntity.PHONE_NUMBER || OnboardEntity.DEPARTMENT_NAME || OnboardEntity.DESIGNATION_NAME)
    }
    const [ isOpenVacantPopup, setIsOpenVacantPopup ] = useState(false)
    const navigate = useNavigate()
    const handleContinue = () => {
        navigate(`/GRC/${currentNode?.displayName}${(vacancyGovData?.[VACANCY_GOV.REGULATION_BOARD] !== 0 || vacancyGovData?.[VACANCY_GOV.REGULATION_LAW] !== 0) ? BODY_PREVIEW.URI : COMPLIANCE_PREVIEW.URI}?bodyType=${vacancyGovData?.[VACANCY_GOV.ACCOUNTABLE_LAW] !== 0 || vacancyGovData?.[VACANCY_GOV.REGULATION_LAW] !== 0 ? 1 : 2}&roleId=${0}&userId=${currentNode?.userId}&matrix=2`)
    }
    const handleCloseModal = () => {
        setIsOpenVacantPopup(false)
    }

    const handleCheck = (e) => {
        if (vacancyGovData?.[VACANCY_GOV.ACCOUNTABLE_LAW] !== 0 || vacancyGovData?.[VACANCY_GOV.ACCOUNTABLE_BOARD] !== 0 || vacancyGovData?.[VACANCY_GOV.REGULATION_BOARD] !== 0 || vacancyGovData?.[VACANCY_GOV.REGULATION_LAW] !== 0) {
            setIsOpenVacantPopup(true)
            setEditState({ right: false })
        } else {
            currentNode?.isVacant ? handleEditFieldsChange(e, 'isVacant') : setOpenWarningVacantPopup({ isOpen: true, name: 'isVacant', value: e })
        }
    }
    const list = (anchor) => (
        <Box role="presentation" sx={{ height: '100%' }}>
            <div className="h-[88%] overflow-auto py-4">
                <div className="flex justify-between items-center pb-3 pr-4 border-b-2">
                    <p className="h-[7%] px-4 pt-[0px] text-h2 flex flex-col justify-center" style={{ color: 'hsl(var(--primary))' }}>{t('Edit User')}</p>
                    <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={() => handleCancelClose()} aria-label="close" disabled={isSubmitting || isLoading || loading}>
                            <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="h-[14%] flex border-b-2 pb-3 px-4 items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <Avatar sx={{ width: 50, height: 50 }} src={currentNode?.profilePic ? `data:${currentNode?.profilePic?.contentType};base64, ${currentNode?.profilePic?.file}` : currentNode?.name} className='mt-4' />
                        <div className='space-x-4 px-4'>
                            <div className='flex mt-4 '>
                                <label className={`flex cursor-pointer ${selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                    <input type="file" accept="image/png, image/jpeg, image/jpg, image/webp" style={{ display: 'none' }} onChange={handleImageChange} disabled={!!selectedImage} />
                                    <img src={'/Common/Icon/ArrowUploadIcon.svg'} alt="Upload icon" />
                                    <span className='mt-2 ml-2 grc-label-one'>{t('Upload')}</span>
                                </label>
                                <div
                                    className={`flex cursor-pointer ml-5 mt-1 ${!selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    onClick={selectedImage ? handleRemoveImage : null}>
                                    <img src={'/Common/Icon/DeleteIcon.svg'} alt="Remove icon" />
                                    <span className='mt-1 ml-2 grc-label-one'>{t('Remove')}</span>
                                </div>
                            </div>
                            <div className='mt-2 grc-label-one text-[12px]'>{t('Image size should not exceed 2MB')}</div>
                        </div>
                    </div>
                    {vacancyGovData?.[VACANCY_GOV.USER_DEPARTMENT]
                        ? vacancyGovData?.[VACANCY_GOV.USER_DEPARTMENT] !== 0 && <div className='w-[20%] h-full flex flex-row justify-center items-center'>
                            <Checkbox name={'isVacant'} checked={currentNode?.isVacant} borderColor='hsl(var(--primary))' onCheckedChange={(e) => handleCheck(e)} />
                            <label className='grc-label ml-2'>{t('Vacant')}</label>
                        </ div>
                        : null}
                </div>
                <div className='h-[73%] mt-3'>
                    <div className="grid grid-cols-3 gap-4 px-4">
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <DropdownTextInput errors={errors} control={control} required={!currentNode.isVacant} rules={{ required: currentNode?.isVacant ? false : t('First Name is Required') }} name='firstName' label={t('First Name')} placeholder={t('Enter First Name')} value={!currentNode.isVacant ? currentNode?.firstName : ''} onValueChange={handleEditFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} name='middleName' label={t('Middle Name')} register={register} placeholder={t('Enter Middle name')} type="text" value={!currentNode.isVacant ? currentNode?.middleName : ''} onValueChange={handleEditFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required={!currentNode.isVacant} rules={{ required: currentNode?.isVacant ? false : t('Last Name is Required') }} name='lastName' label={t('Last Name')} register={register} placeholder={t('Enter Last name')} type="text" value={!currentNode.isVacant ? currentNode?.lastName : ''} onValueChange={handleEditFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required={!currentNode.isVacant} rules={{ required: currentNode?.isVacant ? false : t('Display Name is Required') }} name='displayName' label={t('Display Name')} register={register} placeholder={t('Enter Display Name')} type="text" value={!currentNode.isVacant ? currentNode?.displayName : 'Vacant'} readOnly={currentNode.isVacant} onValueChange={handleEditFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <SearchableSelectInput
                                errors={errors} control={control}
                                required rules={{ required: t('Designation is Required') }}
                                name="designation" label={t('Designation')} placeholder="Search"
                                value={currentNode?.designation || ''}
                                options={desByOrgId?.map((data) => {
                                    return ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status })
                                })}
                                onValueChange={(value) => { handleEditFieldsChange(value, 'designation') }} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='level' label={t('Level')} register={register} placeholder={t('Enter Level')} type="number" value={currentNode?.level} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <SearchableSelectInput
                                errors={errors} control={control}
                                required rules={{ required: t('Department is Required') }}
                                name="department" label={t('Department')} placeholder="Search"
                                value={currentNode?.department || ''}
                                options={depByOrgId?.map((data) => {
                                    return ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status })
                                })}
                                onValueChange={(value) => { handleEditFieldsChange(value, 'department') }} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} setError={setError} control={control} required={!currentNode?.isVacant}
                                rules={{
                                    validate: (value) => {
                                        const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                        if (!currentNode?.isVacant && !value) {
                                            return t('Email ID is required')
                                        } else if (!currentNode?.isVacant && !regexEmail.test(value)) {
                                            return t('Enter a valid email')
                                        }
                                    },
                                    required: currentNode?.isVacant ? false : t('Email ID is required')
                                }}
                                name='emailId' label={t('Email ID')} register={register} placeholder={t('Enter Email ID')} type="text" value={!currentNode.isVacant ? currentNode?.emailId : ''} onValueChange={handleEditFieldsChange} disabled={loading} userId={+currentNode?.userId}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            {/* <Input errors={errors} control={control} required={!currentNode?.isVacant} setError={setError} clearErrors={clearErrors}
                                rules={{
                                    validate: (value) => {
                                        const regexPhone = /^[0-9]{10}$/
                                        if (!value && !currentNode?.isVacant) { return 'Phone number is required' } else if (!regexPhone.test(value) && !currentNode?.isVacant) { return 'Phone number must be 10 digits' }
                                    },
                                    required: !currentNode?.isVacant ? 'Phone number is required' : false
                                }}
                                name='phoneNumber'
                                label={t('Phone Number')}
                                register={register}
                                placeholder={t('Enter Phone Number')}
                                type="text"
                                setValue={setValue}
                                value={!currentNode.isVacant ? currentNode?.phoneNumber : ''}
                                onValueChange={handleEditFieldsChange} /> */}
                            <PhoneNumber
                                name='phoneNumber'
                                label={t('Phone Number')}
                                placeholder={t('Enter phone number')}
                                required={!currentNode?.isVacant}
                                // value={!currentNode?.isVacant ? currentNode?.phoneNumber : ''}
                                value={!currentNode?.isVacant ? currentNode?.phoneNumber ? `${currentNode?.phoneCode || ''}${currentNode?.phoneNumber}` : '' : ''}
                                rules={{
                                    validate: (value) => {
                                        if (!value && !currentNode?.isVacant) { return 'Phone number is required' }
                                        const trimmedValue = value.startsWith('+91') ? value.slice(3).replace(/\s+/g, '').trim() : value.replace(/\s+/g, '').trim()
                                        const regexPhone = /^[0-9]{10}$/
                                        if (!regexPhone.test(trimmedValue) && !currentNode?.isVacant) { return 'Phone Number must be 10 digits' }
                                    },
                                    required: !currentNode?.isVacant ? 'Phone number is required' : false
                                }}
                                register={register} control={control} errors={errors} setError={setError} clearErrors={clearErrors} setValue={setValue}
                                onValueChange={handleEditFieldsChange}
                                disabled={loading}
                                userId={+currentNode?.userId}
                            />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <MultiSelectInput required rules={{ validate: value => value.length > 0 || 'Role is required' }} label={t('Role')} control={control} errors={errors} name="role" placeholder={t('Select Role')} onValueChange={(value) => handleEditFieldsChange(value, 'role')} value={currentNode?.role} options={roleData?.map((data) => { return { id: data?.id, value: data?.name, label: data?.name, status: data?.status } })} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '5%' }}>
                            {/* <DateInput value={currentNode?.fromDate} name='fromDate' register={register} onValueChange={handleEditFieldsChange} label={t('From')} required /> */}
                            <DatePickerInput
                                errors={errors}
                                control={control}
                                required
                                rules={{ required: t('From date is required') }}
                                name='fromDate'
                                label={t('Effective From')}
                                register={register}
                                maxDate={fromMaxDate}
                                type="text"
                                value={currentNode?.fromDate || ''}
                                onValueChange={handleEditFieldsChange}
                                disabled={loading}
                            />
                        </div>
                        {/* <div style={{ width: '100%', marginBottom: '5%' }}>
                            <DatePickerInput
                                errors={errors}
                                control={control}
                                required
                                disabled={currentNode?.isVacant || currentNode?.atPresent}
                                rules={currentNode?.atPresent ? {} : { required: t('To date is required') }}
                                name='toDate'
                                label={t('To')}
                                register={register}
                                type="text"
                                value={currentNode?.atPresent ? '' : currentNode?.toDate }
                                lableComponent={lableComponent}
                                onValueChange={handleEditFieldsChange}
                                minDate={currentNode?.fromDate || ''}
                            />
                        </div> */}
                    </div>
                    {parentNodeValue && <h2 style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', padding: '10px 0px 10px 15px', marginTop: '3px' }} className='border-t-2'>{t('Reports To')}</h2>}
                    {parentNodeValue && <div className="grid grid-cols-3 gap-4 mt-2 px-4">
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Department' label={t('Department')} register={register} placeholder="Enter Department" type="text" value={parentNodeValue?.data?.department || ''} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Designation' label={t('Designation')} register={register} placeholder="Enter Designation" type="text" value={parentNodeValue?.data?.designation || ''} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Name' label={t('Name')} register={register} placeholder="Enter Name" type="text" value={parentNodeValue?.data?.displayName || ''} disabled={loading}/>
                        </div>
                    </div>}
                </div>
            </div>
            <div className="flex justify-end space-x-4 h-[12%] pr-8 items-center">
                <Button
                    variant='outline'
                    style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    disabled={loading}
                    onClick={() => handleCancelClose()}>{t('Cancel')}</Button>
                <Button onClick={() => { handleSubmit(onSubmit)() }} disabled={isSubmitting || isLoading || loading}>
                    {loading ? t('Updating...') : t('Update')}
                </Button>
            </div>
            <Dialog
                maxWidth
                open={openWarningVacantPopup?.isOpen}
                className='vacant-dialouge'
                sx={{
                    '& .MuiDialog-root': {
                        position: 'fixed !important',
                        zIndex: '2000 !important'
                    }
                }}
            >
                <Box sx={{ width: 400 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: '#FFA726', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Warning</div>
                    </DialogTitle>
                    <DialogContent >
                        <Typography sx={{ paddingTop: '20px' }}>
                            Please check the assigned compliance and risk items before vacating the user.
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold', marginTop: '8px' }}>
                            Are you sure? <span style={{ color: '#D32F2F' }}>There is no undo!</span>
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <div className='d-flex content-end'>
                            <Button
                                style={{ backgroundColor: '#FFA726', color: 'hsl(var(--card))', borderColor: '#FFA726', marginRight: '10px' }}
                                onClick={() => {
                                    handleEditFieldsChange(openWarningVacantPopup?.value, openWarningVacantPopup?.name)
                                    setOpenWarningVacantPopup({ isOpen: false, name: 'isVacant', value: null })
                                }}
                            >
                                Yes
                            </Button>
                            <Button variant='outline' style={{ color: '#FFA726', borderColor: '#FFA726' }} onClick={() => setOpenWarningVacantPopup({ isOpen: false })}>
                                No
                            </Button>
                        </div>
                    </DialogActions>
                </Box>
            </Dialog>
        </Box>
    )

    return (
        <div>
            <Dialog
                open={isOpenVacantPopup}
                sx={{ minHeight: '300px' }}
                PaperProps={{
                    style: { minHeight: '180px', minWidth: '350px' }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: '#FFA726', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--card))' }}>Vacant User</div>
                    <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <CrossCircledIcon onClick={() => handleCloseModal()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                    </Tooltip>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '0px 24px 0px 24px', borderBottom: '2px solid hsl(var(--border))' }}>
                    <div className='py-6'>You cannot vacant this user as they have assigned to Regulations and Compliances as Accountable . Please reassign the items before vacating the user.</div>
                    <div className='w-full'>
                        <strong className='text-[#FFA726] !text-left'>Note&nbsp;:&nbsp;</strong>
                    </div>
                    <ul className="list-disc pl-6 space-y-2 pb-6">
                        <li><span className="font-semibold">Risk&nbsp;</span>: All Risks associated with this user will be reassigned to avoid workflow disruptions.</li>
                        <li><span className="font-semibold">Issue&nbsp;</span>: All Issues associated with this user will be reassigned to avoid workflow disruptions</li>
                    </ul>
                </DialogContent>
                <DialogActions sx={{ width: '100%', display: 'flex', padding: '10px', flexDirection: 'row', justifyContent: 'center' }}>
                    <Button onClick={handleContinue} autoFocus>
                                        Preview
                    </Button>
                </DialogActions>
            </Dialog>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 1.8, overflowX: 'hidden', zIndex: 1000 } }}
                className='m-2'
                anchor={'right'}
                open={editState.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list('right')}
            </SwipeableDrawer>
        </div>
    )
}

EditNodeDrawer.propTypes = {
    setCurrentNode: PropTypes.func,
    currentNode: PropTypes.object,
    setEditState: PropTypes.func,
    editState: PropTypes.any,
    onEdit: PropTypes.func,
    nodes: PropTypes.array,
    loading: PropTypes.bool,
    setLoading: PropTypes.bool
}

export default EditNodeDrawer
